define('modules/includes_editor/views/editor',['require','exports','module','base/itemview','cm/lib/codemirror','cm/mode/css/css','cm/mode/javascript/javascript','ldsh!../templates/edit'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview"),
      CodeMirror = require("cm/lib/codemirror"),
      cmcss = require("cm/mode/css/css"),
      cmjs = require("cm/mode/javascript/javascript");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/edit"),
    initialize: function(options){
      this.state = options.state;
      this.vent = options.vent;
      this.editorMode = options.editorMode;
      this.listenTo(this.model, "remove", this.remove);
      this.listenTo(this.vent, "save", this.onSave);
    },
    onShow: function(){
      if(this.codeEditor) return;
      var editorDomElement = document.getElementById("includeEditor");
      this.codeEditor = CodeMirror.fromTextArea(editorDomElement, {
        mode: this.editorMode || "css",
        lineNumbers: true,
        autofocus: true,
        lineWrapping: true
      });
      this.codeEditor.setValue(this.model.get("content"));
      this.codeEditor.on("change", _.bind(this.vent.trigger, this.vent, "editor:content:change"));
    },
    onSave: function(){
      var content = this.codeEditor.getValue();
      this.model.set({
        head: this.scriptLocation(),
        content: content,
        isTag: this.isTag(content)
      });
    },
    isTag: function(content) {
      return !content.trim().indexOf("<script") || !content.trim().indexOf("<link ");
    },
    scriptLocation: function() {
      return $(".scriptLocation").is(":checked");
    }
  });
});

